module.exports = __webpack_public_path__ + "img/Y4JT Justice League.4b7b67ad.jpeg";